/* eslint-disable */

/*
 * ⚠️ DO NOT EDIT ⚠️
 * This file is automatically generated, run "yarn run codegen"
 */

/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type LivePostItemFragment = {
  __typename: 'lives_post';
  id: number;
  _created: unknown;
  data: unknown;
  picture: string | undefined;
  action_id: number | undefined;
  live_id: number | undefined;
  deleted: boolean | undefined;
  team_official_reporter_id: number | undefined;
  spectator:
    | {
        __typename: 'lives_spectator';
        id: number;
        name: string | undefined;
        picture_url: string | undefined;
        user_id: number | undefined;
      }
    | undefined;
  action:
    | {
        __typename: 'lives_action';
        id: number;
        action_type: string | undefined;
        icon: string | undefined;
        data: unknown;
        name: string | undefined;
        rank: unknown;
        translation_key: string | undefined;
      }
    | undefined;
};

export const LivePostItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LivePostItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'lives_post' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: '_created' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'spectator' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'picture_url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'user_id' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          { kind: 'Field', name: { kind: 'Name', value: 'picture' } },
          { kind: 'Field', name: { kind: 'Name', value: 'action_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'action' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'translation_key' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'client' },
                    },
                  ],
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'live_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleted' },
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'team_official_reporter_id' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LivePostItemFragment, unknown>;
